import { render } from "./YouTubeSubscribers.vue?vue&type=template&id=40244d0b&scoped=true&ts=true"
import script from "./YouTubeSubscribers.vue?vue&type=script&lang=ts"
export * from "./YouTubeSubscribers.vue?vue&type=script&lang=ts"

import "./YouTubeSubscribers.vue?vue&type=style&index=0&id=40244d0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40244d0b"]])

export default __exports__